import { config } from './config';

export const FRAMES_PER_SECOND = config.defaultFramesPerSecond;

export const adaptSliceToDto = slice => ({
    ...slice,
    start: slice.start,
    end: slice.end,
    startFrames: slice.start * FRAMES_PER_SECOND,
    endFrames: slice.end * FRAMES_PER_SECOND,
    duration: slice.duration,
    durationFrames: slice.duration * FRAMES_PER_SECOND,
})